import { render, staticRenderFns } from "./ManageSliderMetadata.vue?vue&type=template&id=8e7054aa&scoped=true&"
import script from "./ManageSliderMetadata.vue?vue&type=script&lang=js&"
export * from "./ManageSliderMetadata.vue?vue&type=script&lang=js&"
import style0 from "./ManageSliderMetadata.vue?vue&type=style&index=0&id=8e7054aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7054aa",
  null
  
)

export default component.exports